import Service from "../AuthService";

const User = {
  getUserList() {
    return Service.get(`settings/users`);
  },
  createUser(payload, token) {
    return Service.post(`settings/users?token=${token}`, payload);
  },
  updateUser(payload, id, token) {
    return Service.put(`settings/users/${id}?token=${token}`, payload)
  },
  deleteUser(id, token) {
    return Service.delete(`settings/users/${id}?token=${token}`)
  },
  fetchUserHistory(filters) {
    let url = `settings/user-history`

    Object.entries(filters).forEach(([key, value]) => {
      if (Object.keys(filters)[0] === key) {
        url += `?`
      } else {
        url += `&`
      }

      url += `${key}=${value}`
    })

    return Service.get(`${url}`);
  }
};

export default User;
